import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../shared/services/api-service/api-service';
import { ContentAreas } from './content-area-interface';

@Injectable()
export class RespondService {
  constructor (private apiService: ApiService) {}

  public getRowData (schoolId: string, contentArea: ContentAreas): Observable<any> {
    const query = `{
      Respond(schoolId: "${schoolId}", contentArea: "${contentArea}") {
        _id
        OSIS_NUMBER
        group
        subGroup
        examKey
        examName
      }
    }`;

    const payload = { query, fetchPolicy: 'no-cache' };

    return this.apiService.getStudentsGraphQL(payload).pipe(
      map((res: any) => {
        const {
          data: { Respond: rowData },
        } = res;
        return rowData;
      }),
    );
  }
}
